import { render, staticRenderFns } from "./PanelCustomer.vue?vue&type=template&id=041f8a18&lang=pug&"
import script from "./PanelCustomer.vue?vue&type=script&lang=js&"
export * from "./PanelCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports